module.exports = __webpack_public_path__ + "media/ca_slide24_audio.0a5852b4.mp4";